<template>
<div class="kpi-container">

    <h2 class="globalHeaderWithSubHeader">Mein {{month.formatKapitelMonth(props.selectedMonth)}}</h2>
    <h4 class="globalHeaderWithSubHeader">in Zahlen</h4>
    <MonthKpiPlanningSummary :selectedMonth="selectedMonth"/>

    <h2 class="globalHeaderWithSubHeader">Mein Beitrag</h2>
    <h4 class="globalHeaderWithSubHeader"><!--zum Umsatz & -->zum Jahresüberschuss</h4>
    <MonthKpiRevenueAndExcessContribution :selectedMonth="selectedMonth"/>

    <h2 class="globalHeaderWithSubHeader">Jahresüberschuss</h2>
    <h4 class="globalHeaderWithSubHeader">aller Fachkräfte bei <b style="color:var(--ion-color-superblack-tint)">ines</b></h4>
    <MonthKpiCompany :selectedMonth="selectedMonth"/>

</div>
</template>

<script setup lang="ts">
import {PropType, ref, Ref} from 'vue';
import {DataLoader} from "@/helper/dataLoader";
import {PayrollStatus} from "@/graphql/generated/graphql";

import {kapitelMonthString} from '@/graphql/kapitelTypes';
import MonthKpiRevenueAndExcessContribution
    from "@/views/components/MonthKPI/section/MonthKPIRevenueAndExcessContribution.vue";
import MonthKpiCompany from "@/views/components/MonthKPI/section/MonthKPICompany.vue";
import MonthKpiPlanningSummary from "@/views/components/MonthKPI/section/MonthKPIPlanningSummary.vue";
import month from "@/helper/datetime/month";
import {fetchPayrollStatusForMonth, setPayrollStatusSeen} from "@/helper/monthKPI/monthKpiPayroll";
import {useAuthStore} from "@/store/auth";
import {isMostRecentPublishedMonth} from "@/helper/monthKPI/monthKPI";

const props = defineProps({
    selectedMonth: {
        type: String as PropType<kapitelMonthString>,
        required: true,
    }
});
</script>

<style lang="scss" scoped>
.kpi-container {
    display: flex;
    flex-direction: column;
}
</style>
